import { Typography } from '@mui/material';
import DrilldownDialog from './DrilldownDialog';
import { CASE_LABEL, atsAdmissionsUrl } from './atsAdmissions';
import { Date1, Stack2 } from './drilldownCells';

// The popup behind a CRO's "Course enrollments" count on ATS: the enrollments that were averaged into that row (one case: actual
// or forecasted), one row each - the student, the course and program, the admission date (the day the first real payment arrived),
// the first class (none yet for forecasted) and the days. The row's ATS is the average of the Days column.
// Longest wait first: it is what pulls the average up.
const COLUMNS = [
  { key: 'name', label: 'Student', sort: (r) => (r.name || '').toLowerCase(), render: (r) => <Stack2 top={r.name} bottom={r.admnNo ? `Admn ${r.admnNo}` : ''} />, csv: (r) => r.name },
  { key: 'admnNo', label: 'Admn no', sort: (r) => String(r.admnNo || ''), render: (r) => <Typography variant="body2" fontWeight={600}>{r.admnNo || '-'}</Typography>, csv: (r) => r.admnNo },
  { key: 'course', label: 'Course', sort: (r) => (r.course || '').toLowerCase(), render: (r) => <Stack2 top={r.course} bottom={r.program} />, csv: (r) => r.course },
  { key: 'admissionDate', label: 'Admission date', sort: (r) => r.admissionDate || '', render: (r) => <Date1 value={r.admissionDate} dateOnly />, csv: (r) => r.admissionDate },
  { key: 'firstClassDate', label: 'First class', sort: (r) => r.firstClassDate || '9999', render: (r) => <Date1 value={r.firstClassDate} dateOnly empty="Not started" />, csv: (r) => r.firstClassDate || 'Not started' },
  {
    key: 'days', label: 'Days', align: 'right', sort: (r) => r.days,
    render: (r) => <Typography variant="body2" fontWeight={700} sx={{ fontVariantNumeric: 'tabular-nums' }}>{r.days}</Typography>, csv: (r) => r.days,
  },
];

const searchText = (r) => [r.name, r.admnNo, r.course, r.program].filter(Boolean).join(' ').toLowerCase();

const AtsAdmissionsDialog = ({ request, onClose }) => {
  const { userName, caseType, month } = request;
  return (
    <DrilldownDialog
      url={atsAdmissionsUrl(request)}
      title="Course enrollments"
      chips={[userName, `${CASE_LABEL[caseType]} cases`, month.format('MMMM YYYY')]}
      dataChips={(d) => [d.averageDays !== null && d.averageDays !== undefined ? `Average ${d.averageDays} days` : null]}
      columns={COLUMNS}
      searchText={searchText}
      searchLabel="Search these enrollments"
      searchPlaceholder="Search student, admn no, course"
      emptyText="No course enrollments."
      rowKey={(r) => r.enrollmentId}
      csvName={`ATS_${CASE_LABEL[caseType]}_${(userName || 'CRO').replace(/\W+/g, '_')}_${month.format('YYYY-MM')}.csv`}
      onClose={onClose}
    />
  );
};

export default AtsAdmissionsDialog;
